export default function pathHistory(state = [], action) {
  if (action.type === 'UPDATE_CURRENT_PATH') {
    return [action.payload, ...state]
  }

  return state
}

export function getCurrentPath(state) {
  const currentPath = state.pathHistory[0]

  return currentPath ? currentPath.name : null
}

export function getLastPath(state) {
  const lastPath = state.pathHistory[1]

  return lastPath ? lastPath.name : null
}

export function getCurrentHash(state) {
  const currentPath = state.pathHistory[0]

  return currentPath ? currentPath.hash : null
}

export function getSubcategorySegmentOfCurrentPath(state) {
  const currentPath = state.pathHistory[0]

  if (currentPath) {
    const splitPath = currentPath.name.split('/')
    if (splitPath[1] === 'collections' && splitPath.length === 4) {
      return splitPath[splitPath.length - 1]
    }
  }
}

export function getSubcategorySlug(state, collectionPermalink) {
  const recentHistory = state.pathHistory.slice(0, 2)
  const matchingPath = recentHistory.find(path => {
    return path.name.includes(`collections/${collectionPermalink}`)
  })

  if (matchingPath) {
    const splitPath = matchingPath.name.split('/')

    if (splitPath.length > 3) {
      return splitPath[splitPath.length - 1]
    }
  }
}
